import { useLang } from "@/i18n/LangContext";
import { IMAGES } from "@/lib/images";
import { Waves, Landmark, UtensilsCrossed, Mountain } from "lucide-react";

const icons = [Waves, Landmark, UtensilsCrossed, Mountain];

export default function Loano() {
  const { t } = useLang();
  return (
    <section
      id="loano"
      data-testid="loano-section"
      className="py-24 sm:py-32 bg-[#F0EDE6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-4">
              {t.loano.overline}
            </p>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#121C26] max-w-xl">
              {t.loano.title}
            </h2>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={IMAGES.beach}
                alt="Loano beach"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#E0DACE]">
            {t.loano.items.map((it, i) => {
              const Icon = icons[i];
              return (
                <div
                  key={i}
                  data-testid={`loano-item-${i}`}
                  className="bg-[#FAF9F6] p-8 sm:p-10"
                >
                  <Icon size={26} strokeWidth={1.25} className="text-[#0097b2] mb-5" />
                  <h3 className="font-serif text-2xl text-[#121C26] mb-3">{it.title}</h3>
                  <p className="text-[#4A5D6B] leading-relaxed text-sm">{it.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
